import React, { useState } from 'react';
import 'leaflet/dist/leaflet.css';
import CallLogsPage from './CallLog/pages/CallLogsPage';
import DispatchMap from './CallLog/components/DispatchMap';
import NavHeightAdjust from '../../../../components/navbar/NavHeightAdjust';
import DispatchPage from './CallLog/pages/DispatchPage';

// Inline style objects
const styles = {
  dashboardContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    fontFamily: 'Arial, sans-serif',
  },
  header: {
    backgroundColor: '#f5f5f5',
    padding: '20px',
    textAlign: 'center',
    borderBottom: '1px solid #ddd',
  },
  navList: {
    listStyle: 'none',
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    padding: 0,
    margin: '10px 0 0',
  },
  navItem: {
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  dashboardMain: {
    display: 'flex',
    flex: 1,
  },
  leftPanel: {
    flex: 1,
    padding: '20px',
    borderRight: '1px solid #ddd',
    overflowY: 'auto',
  },
  rightPanel: {
    flex: 1,
    padding: '20px',
    overflowY: 'auto',
  },
  section: {
    marginBottom: '20px',
  },
  sectionTitle: {
    marginBottom: '10px',
    borderBottom: '2px solid #333',
    paddingBottom: '5px',
  },
  ticketListItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 0',
    borderBottom: '1px solid #eee',
  },
  dispatchTable: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  dispatchTableHeader: {
    backgroundColor: '#f5f5f5',
  },
  dispatchTableCell: {
    border: '1px solid #ddd',
    padding: '8px',
  },
  mapContainer: {
    height: '300px',
    width: '100%',
    marginBottom: '20px',
  },
  notificationItem: {
    padding: '8px 0',
    borderBottom: '1px solid #eee',
  },
  formGroup: {
    marginBottom: '10px',
  },
  formLabel: {
    display: 'block',
    marginBottom: '5px',
    fontWeight: 'bold',
  },
  formInput: {
    width: '100%',
    padding: '8px',
    boxSizing: 'border-box',
  },
  button: {
    padding: '10px 15px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
  },
  actionItem: {
    padding: '8px 0',
    borderBottom: '1px solid #eee',
  },
};

// Main dashboard component
const AdvancedCallCenterDashboard = () => {
  const [mapData, setMapData] = useState([]);
  const [mechanics, setMechanics] = useState([]);

  const [latestDispatchedCall, setLatestDispatchedCall] = useState(null);


  return (
    <NavHeightAdjust>
      <div style={styles.dashboardContainer}>
        <div style={styles.dashboardMain}>
          <div style={styles.leftPanel}>
            <CallLogsPage mechanics={mechanics} setMechanics={setMechanics} latestDispatch={latestDispatchedCall} setLatestDispatch={setLatestDispatchedCall} />
            <DispatchPage mechanics={mechanics} latestDispatch={latestDispatchedCall} setLatestDispatch={setLatestDispatchedCall} setMapData={setMapData} />
          </div>
          <div style={styles.rightPanel}>
            <DispatchMap data={mapData} mechanics={mechanics} />
          </div>
        </div>
      </div>
    </NavHeightAdjust>
  );
};


export default AdvancedCallCenterDashboard;